<template>
  <div>

      <Card>
        <Form @keydown.native.enter.prevent="doSubmit" :label-width="140" :model="formData">
          <Row>
          <Col span="12">
            <FormItem label="站点类型：" prop="station_type">
              <Select v-model="formData.station_type">
                <Option value="">所有站点</Option>
                <Option value="2">小油</Option>
                <Option value="3">撬装</Option>
                <Option value="4">加油站</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="省市区：" prop="province">
              <Select v-model="formData.province" style="width: 33%" placeholder="省" @on-change="changeProvince">
                <Option value="">请选择</Option>
                <Option v-for="(item,key) in provinces" :value="item" :key="key">{{item}}</Option>
              </Select>
              <Select v-model="formData.city" style="width: 33%" placeholder="市" @on-change="changeCity">
                <Option value="">请选择</Option>
                <Option v-for="(item,key) in citys" :value="item" :key="key">{{item}}</Option>
              </Select>
              <Select v-model="formData.county" style="width: 33%" placeholder="区">
                <Option value="">请选择</Option>
                <Option v-for="(item,key) in countys" :value="item" :key="key">{{item}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="油价：" prop="percentage">
              <Input v-model="formData.price" placeholder="不填则不设置"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="联系人名称：" prop="percentage">
              <Input v-model="formData.contact_user" placeholder="">
                <span slot="append">填写覆盖，不填则不改</span>
              </Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="联系人电话：" prop="percentage">
              <Input v-model="formData.contact_mobile" placeholder="">
                <span slot="append">填写覆盖，不填则不改</span>
              </Input>
            </FormItem>
          </Col>

          <Form-item>
            <Button type="primary" @click="doSubmit">确定</Button>
          </Form-item>
        </Row>
        </Form>
      </Card>

    <!--<Card title="挂牌价定时设置">
      <Form @keydown.native.enter.prevent="doSubmit" :label-width="140" :model="formData">
        <Row>
          <Col span="12">
            <FormItem label="省市区：" prop="province">
              <Select v-model="formData.province" style="width: 33%" placeholder="省" @on-change="changeProvince">
                <Option value="">请选择</Option>
                <Option v-for="(item,key) in provinces" :value="item" :key="key">{{item}}</Option>
              </Select>
              <Select v-model="formData.city" style="width: 33%" placeholder="市" @on-change="changeCity">
                <Option value="">请选择</Option>
                <Option v-for="(item,key) in citys" :value="item" :key="key">{{item}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="挂牌价：" prop="percentage">
              <Input v-model="formData.price" placeholder="不填则不设置"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="执行时间：" prop="percentage">

            </FormItem>
          </Col>
          <Form-item>
            <Button type="primary" @click="doSubmit">确定</Button>
          </Form-item>
        </Row>
      </Form>
    </Card>-->


  </div>
</template>

<script>
  import Editor from '@/components/editor'
  import config from '@/config/base-config'
  export default {
    name: "edit",
    components:{Editor},
    data(){
      return {
        formData:{
          station_type:'',
          province:'',
          city:'',
          county:'',
          price:'',
          contact_user:'',
          contact_mobile:'',
        },
        province_county_data:[],    //省市区数据
        provinces:[],
        citys:[],
        countys:[],
      }
    },
    methods:{
      async getInfo(){

      },
      init(){
        this.$commonFun.postProxy('admin/tuanyou/getProvince',{}).then((res)=>{
          this.province_county_data = res.data.province_county_data;
          this.provinces = res.data.province_data
        })
      },
      async doSubmit(){
        let res = await this.$commonFun.postProxy('admin/gas/setPrice',this.formData)
        this.$commonFun.dealApiResult(res)
        // this.getInfo()
      },
      changeProvince(province){
        this.citys = []
        this.province_county_data.forEach((item,key)=>{
          if (item.value === province){
            item.children.forEach(val=>{
              this.citys.push(val.value)
            })
          }
        })
      },
      changeCity(city){
        this.countys=[]
        let province = this.formData.province
        this.province_county_data.forEach((item,key)=>{
          if (item.value === province){
            item.children.forEach((val)=>{
              if (val.value === city){
                val.children.forEach(val=>{
                  this.countys.push(val.value)
                })
              }
            })

          }
        })
      },
    },
    mounted() {
      this.getInfo()
      this.init()
    },
  }
</script>

<style scoped>

</style>
